import { Link } from 'react-router';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AccedoLogo from '../components/AccedoLogo';

/**
 * 404 Not Found page with MUI layout.
 */
function NotFoundPage() {
    return (
        <Box className="not-found-page" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Box className="landing-header" component="header">
                <Container>
                    <Box className="landing-nav" component="nav" sx={{ display: 'flex', alignItems: 'center', py: 2 }}>
                        <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
                            <AccedoLogo size={40} />
                            Accedo
                        </Link>
                        <Box className="nav-links" sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Link to="/" className="nav-link">
                                Home
                            </Link>
                            <Button component={Link} to="/login" variant="contained" className="btn btn-primary">
                                Sign In
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>

            <Box component="main" className="not-found-main" sx={{ flex: 1, py: 8 }}>
                <Container>
                    <Typography variant="h4" component="h1" gutterBottom>
                        404 &mdash; Page Not Found
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        The page you are looking for does not exist or has been moved.
                    </Typography>
                    <Box className="not-found-actions">
                        <Button component={Link} to="/" variant="contained" size="large" className="btn btn-primary btn-large">
                            Go Back Home
                        </Button>
                    </Box>
                </Container>
            </Box>

            <Box component="footer" className="landing-footer" role="contentinfo" sx={{ py: 3 }}>
                <Container>
                    <Typography variant="body2" color="text.secondary">
                        &copy; {new Date().getFullYear()} Accedo. All rights reserved.
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
}

export default NotFoundPage;
